'use client'
import Xpayzmarket from '@svg/xpayzmarket.svg'
import Burger from '@svg/burger.svg'
import Close from '@svg/close.svg'
import {usePathname, useRouter} from 'next/navigation'
import Button from './common/Button'
import {useState} from 'react'

export default function Navigation({fromHome = false}: {fromHome?: boolean}) {
  const router = useRouter()
  const pathname = usePathname()
  const [open, setOpen] = useState(false)

  const urls = [
    {text: 'Features', url: '/'},
    {text: 'How it Works', url: '/how-it-works'},
    {text: 'Pricing', url: '/pricing'},
    {text: 'Contact', url: '/contact'},
  ]

  if (!fromHome && pathname === '/') return null

  return (
    <nav className={`px-8 py-8 z-10 ${pathname !== '/' ? 'bg-[linear-gradient(315deg,#000000,#1A0000,#2D0A0A)]' : ''}`}>
      <div className="flex flex-col rounded-3xl bg-background px-10 py-5 transition-all duration-300">
        {/* Top row */}
        <div className="flex justify-between items-center">
          <Xpayzmarket className="w-37.5 md:w-44.25" />

          {/* Desktop */}
          <ul className="hidden lg:flex gap-16">
            {urls.map((url, index) => (
              <li
                key={index}
                className={`font-medium cursor-pointer ${pathname === url.url ? 'text-primary-400 underline' : ''}`}>
                <a onClick={() => router.push(url.url)}>{url.text}</a>
              </li>
            ))}
          </ul>

          <div className="hidden lg:block">
            <Button variant="primary" onClick={() => router.push('/')}>
              Start Free Trial
            </Button>
          </div>

          <button className="lg:hidden flex flex-col gap-1 text-primary-400" onClick={() => setOpen(!open)}>
            {!open ? <Burger className="w-8 h-8" /> : <Close className="w-8 h-8" />}
          </button>
        </div>

        {/* Mobile menu */}
        <div className={`lg:hidden overflow-hidden transition-all duration-300 ${open ? 'max-h-125 mt-6' : 'max-h-0'}`}>
          <ul className="flex flex-col gap-6">
            {urls.map((url, index) => (
              <li key={index} className={`font-medium ${pathname === url.url ? 'text-primary-400 underline' : ''}`}>
                <a
                  className="cursor-pointer"
                  onClick={() => {
                    router.push(url.url)
                    setOpen(false)
                  }}>
                  {url.text}
                </a>
              </li>
            ))}
          </ul>

          <div className="mt-6">
            <Button
              variant="primary"
              className="w-full cursor-pointer"
              onClick={() => {
                router.push('/')
                setOpen(false)
              }}>
              Start Free Trial
            </Button>
          </div>
        </div>
      </div>
    </nav>
  )
}
